export default "__VITE_ASSET__BA5pMm7q__"